/* ============================================================
   ILEV · PACKS DE 3 MESES EN EL CARRITO  (25-sep-2026)
   ------------------------------------------------------------
   Pedido de Franco: en el carrito (panel lateral y /cart),
     · con el + , al llegar a 3 DÚOs de 30 días se cambian por
       1 × "3 MESES de DUO"; al llegar a 3 Bombas de 30 cáps, por
       1 × "Bomba Nutricional 90 cápsulas".
     · con el − sobre el pack, el pack se deshace en 2 sueltos
       (3 MESES de DUO → 2 DÚOs · Bomba 90 → 2 Bombas de 30).
   Se cuenta en "meses": sueltos + 3 × packs. Cada cambio se
   reparte en la mayor cantidad de packs posible y el resto sueltos.
   "Eliminar" borra la línea como siempre (no deshace el pack).
   Líneas con propiedades (regalos) no se tocan.

   Cómo: envuelve CartForm.updateCartQty (assets/component-cart.js)
   sin editar el archivo del tema. Si algo falla, cae al
   comportamiento normal del tema.
   Lo carga snippets/ilev-carrito-carga.liquid.
   ============================================================ */
(function () {
  'use strict';
  if (window.__ilevPacks) return;
  window.__ilevPacks = true;

  var REGLAS = [
    { suelto: 44077689536693, pack: 44793312968885, n: 3 },  /* DÚO 30 días ↔ 3 MESES de DUO */
    { suelto: 43620701995189, pack: 53379548020917, n: 3 }   /* Bomba 30 cáps ↔ Bomba 90 cáps */
  ];

  /* qué botón disparó el cambio: el tema no lo dice, así que se anota
     en el clic (fase de captura, antes que el tema) */
  var origen = null;
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.qty-minus, .qty-plus, [data-js-cart-item] .remove');
    if (!t) return;
    origen = t.classList.contains('qty-minus') ? 'menos'
           : t.classList.contains('qty-plus') ? 'mas' : 'quitar';
  }, true);

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
  }

  function sinProps(li) { return !li.properties || Object.keys(li.properties).length === 0; }

  /* Devuelve una promesa con true si hizo el cambio, o null si le toca al tema */
  function aplicarRegla(cart, key, nueva, org) {
    var li = null, i;
    for (i = 0; i < cart.items.length; i++) if (cart.items[i].key === key) { li = cart.items[i]; break; }
    if (!li || !sinProps(li)) return null;

    var R = null;
    for (i = 0; i < REGLAS.length; i++) {
      if (REGLAS[i].suelto === li.variant_id || REGLAS[i].pack === li.variant_id) { R = REGLAS[i]; break; }
    }
    if (!R) return null;

    var lSuelto = null, lPack = null;
    cart.items.forEach(function (x) {
      if (!sinProps(x)) return;
      if (x.variant_id === R.suelto && !lSuelto) lSuelto = x;
      if (x.variant_id === R.pack && !lPack) lPack = x;
    });
    var S = lSuelto ? lSuelto.quantity : 0;
    var P = lPack ? lPack.quantity : 0;
    var T;

    if (li.variant_id === R.suelto) {
      if (nueva <= li.quantity) return null;          /* bajar sueltos: normal */
      T = nueva + P * R.n;
    } else {
      if (org !== 'menos' || nueva >= li.quantity) return null;  /* solo el − del pack */
      var deshechos = li.quantity - nueva;
      T = S + nueva * R.n + deshechos * (R.n - 1);
    }

    var nP = Math.floor(T / R.n), nS = T % R.n;
    if (li.variant_id === R.suelto && nP === P) return null;  /* no alcanza para un pack */

    /* primero lo que se agrega (si falla por stock, no se tocó nada) */
    var agregar = [];
    if (!lPack && nP > 0) agregar.push({ id: R.pack, quantity: nP });
    if (!lSuelto && nS > 0) agregar.push({ id: R.suelto, quantity: nS });
    var updates = {};
    if (lPack) updates[lPack.key] = nP;
    if (lSuelto) updates[lSuelto.key] = nS;

    var p = agregar.length ? post('/cart/add.js', { items: agregar }) : Promise.resolve();
    return p.then(function () {
      return Object.keys(updates).length ? post('/cart/update.js', { updates: updates }) : null;
    }).then(function () { return true; });
  }

  function repintar() {
    if (document.body.classList.contains('template-cart')) { location.reload(); return; }
    if (typeof window.refreshCart === 'function') window.refreshCart();
    else location.reload();
  }

  function instalar() {
    var CF = customElements.get('cart-form');
    if (!CF || CF.prototype.__ilevPacks) return;
    CF.prototype.__ilevPacks = true;
    var orig = CF.prototype.updateCartQty;

    CF.prototype.updateCartQty = function (item, nueva) {
      var self = this, org = origen;
      origen = null;
      if (org === 'quitar' || !item || isNaN(nueva)) return orig.call(self, item, nueva);
      var key = item.getAttribute('data-id');
      if (self.form) self.form.classList.add('processing');

      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { return aplicarRegla(cart, key, nueva, org); })
        .then(function (hecho) {
          if (hecho) { repintar(); return; }
          if (self.form) self.form.classList.remove('processing');
          orig.call(self, item, nueva);
        })
        .catch(function () {
          if (self.form) self.form.classList.remove('processing');
          orig.call(self, item, nueva);
        });
    };
  }

  if (window.customElements) {
    if (customElements.get('cart-form')) instalar();
    else customElements.whenDefined('cart-form').then(instalar);
  }
})();
